"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
	for (var name in all) __defProp(target, name, {
		get: all[name],
		enumerable: true
	});
};
var __copyProps = (to, from, except, desc) => {
	if (from && typeof from === "object" || typeof from === "function") {
		for (let key of __getOwnPropNames(from)) if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
			get: () => from[key],
			enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
		});
	}
	return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var constants_exports = {};
__export(constants_exports, {
	CACHE_KEY: () => CACHE_KEY,
	CSS_PRELOAD_JS_POSTFIX: () => CSS_PRELOAD_JS_POSTFIX,
	CSS_PRELOAD_JS_POSTFIX_REGEX: () => CSS_PRELOAD_JS_POSTFIX_REGEX,
	LOADER_JS_POSTFIX: () => LOADER_JS_POSTFIX,
	LOADER_JS_POSTFIX_REGEX: () => LOADER_JS_POSTFIX_REGEX,
	LOADER_JS_POSTFIX_REGEX_STRING: () => LOADER_JS_POSTFIX_REGEX_STRING,
	LOADER_JS_POSTFIX_UNCACHED: () => LOADER_JS_POSTFIX_UNCACHED,
	PRELOAD_JS_POSTFIX: () => PRELOAD_JS_POSTFIX,
	PRELOAD_JS_POSTFIX_REGEX: () => PRELOAD_JS_POSTFIX_REGEX,
	SERVER_CONTEXT_KEY: () => SERVER_CONTEXT_KEY,
	VIRTUAL_SSR_CSS_ENTRY: () => VIRTUAL_SSR_CSS_ENTRY,
	VIRTUAL_SSR_CSS_HREF: () => VIRTUAL_SSR_CSS_HREF,
	getSpaHeaderElements: () => getSpaHeaderElements,
	hasWebHistory: () => hasWebHistory,
	isNative: () => isNative,
	isWebClient: () => isWebClient,
	isWebServer: () => isWebServer,
	setCacheKey: () => setCacheKey
});
module.exports = __toCommonJS(constants_exports);
var import_htmlEscape = require("./utils/htmlEscape");
var _process_env_ONE_CACHE_KEY;
var isWebClient = false;
var isWebServer = false;
var isNative = true;
var hasWebHistory = isWebClient && typeof window.history !== "undefined" && typeof window.location !== "undefined";
var CACHE_KEY = `${(_process_env_ONE_CACHE_KEY = process.env.ONE_CACHE_KEY) !== null && _process_env_ONE_CACHE_KEY !== void 0 ? _process_env_ONE_CACHE_KEY : Math.round(Math.random() * 1e8)}`;
var LOADER_JS_POSTFIX_UNCACHED = `_vxrn_loader.js`;
var LOADER_JS_POSTFIX_REGEX_STRING = `_\\d+${LOADER_JS_POSTFIX_UNCACHED}$`;
var LOADER_JS_POSTFIX_REGEX = new RegExp(LOADER_JS_POSTFIX_REGEX_STRING);
var LOADER_JS_POSTFIX = `_${CACHE_KEY}${LOADER_JS_POSTFIX_UNCACHED}`;
var PRELOAD_JS_POSTFIX = `_${CACHE_KEY}_preload.js`;
var CSS_PRELOAD_JS_POSTFIX = `_${CACHE_KEY}_preload_css.js`;
var PRELOAD_JS_POSTFIX_REGEX = /_\d+_preload\.js$/;
var CSS_PRELOAD_JS_POSTFIX_REGEX = /_\d+_preload_css\.js$/;
function setCacheKey(key) {
	if (!key || key === CACHE_KEY) return;
	CACHE_KEY = key;
	LOADER_JS_POSTFIX = `_${CACHE_KEY}${LOADER_JS_POSTFIX_UNCACHED}`;
	PRELOAD_JS_POSTFIX = `_${CACHE_KEY}_preload.js`;
	CSS_PRELOAD_JS_POSTFIX = `_${CACHE_KEY}_preload_css.js`;
}
var VIRTUAL_SSR_CSS_ENTRY = `virtual:ssr-css.css`;
var VIRTUAL_SSR_CSS_HREF = `/@id/__x00__${VIRTUAL_SSR_CSS_ENTRY}`;
var SERVER_CONTEXT_KEY = "__one_server_context__";
var getSpaHeaderElements = function() {
	var { serverContext = {} } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
	return `
  <script>globalThis['global'] = globalThis<\/script>
  <script>globalThis['__vxrnIsSPA'] = true<\/script>
  <script>globalThis["${SERVER_CONTEXT_KEY}"] = ${(0, import_htmlEscape.safeJsonStringify)(serverContext)}<\/script>
  <script>globalThis.__oneLoadedCSS = new Set(${(0, import_htmlEscape.safeJsonStringify)(serverContext.css || [])})<\/script>
`;
};
//# sourceMappingURL=constants.js.map
